module.exports = __webpack_public_path__ + "static/Centipede-dc735904e2a4634e4d02f8a8b8ea5a86.jpg";